import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "react-bootstrap";
import logoPolimi from "../../assets/images/logoPolimi.png";
import { FContainer } from "./Footer.styles";
import { HashLink as Link } from "react-router-hash-link";

const Footer = () => {
  const { t } = useTranslation("", { keyPrefix: "components.footer" });

  return (
    <FContainer dark="true" className="mx-0 px-0" fluid>
      <Container className="py-4">
        <Row>
          <Col lg={3} xs={6} className="mb-2">
            <img src={logoPolimi} alt="Politecnico di Milano" />
          </Col>
          <Col lg={3} xs={6} className="mb-2">
            <h4>{t("project")}</h4>
            <Link to="#about">
              <p>{t("about")}</p>
            </Link>
            <Link to="#services">
              <p>{t("features")}</p>
            </Link>
            {/*             <Link to="#contact">
              <p>{t("contact_us")}</p>
            </Link> */}
          </Col>
          <Col lg={3} xs={6} className="mb-2">
            <h4>{t("who_we_are")}</h4>
            <Link to="#team">
              <p>{t("meet_the_team")}</p>
            </Link>
          </Col>
          <Col lg={3} xs={6} className="mb-2">
            <h4>{t("conditions")}</h4>
            <Link href="#">
              <p>{t("privacy_policy")}</p>
            </Link>
          </Col>
        </Row>
      </Container>
    </FContainer>
  );
};

export default Footer;
